import api from './serviceApi'; // Import the axios instance

const tokenApi = {
    /**
     * Get token
     * @param {Object} data - The user payload.
     * @returns {Promise<Object>} - The created user data.
     */
    getToken: async (data) => {
        try {
            const response = await api.post('/token', data);
            return response.data;
        } catch (error) {
            console.error('Error to get token:', error);
            throw error;
        }
    }
};

export default tokenApi;
